import { render, staticRenderFns } from "./ParentCategoryEdit.vue?vue&type=template&id=92b1b498&scoped=true&"
import script from "./ParentCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./ParentCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b1b498",
  null
  
)

export default component.exports